import { render, staticRenderFns } from "./SidePanelPermissionCard.vue?vue&type=template&id=632054a4&scoped=true&"
import script from "./SidePanelPermissionCard.ts?vue&type=script&lang=ts&"
export * from "./SidePanelPermissionCard.ts?vue&type=script&lang=ts&"
import style0 from "./SidePanelPermissionCard.scss?vue&type=style&index=0&id=632054a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632054a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
